export const host_url: string = window.location.origin; 